import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { DEFAULT_IMAGE_SRC } from "@constants";
import styles from "./style/Avatar.module.css";
import { replaceErrorAvatar } from "@helpers";

const Avatar = ({ src, width, height, className, isProcessing }) => {
  return (
    <span className={clsx(styles.avatar, className)}>
      <img
        src={isProcessing || !src ? DEFAULT_IMAGE_SRC : src}
        alt="avatar"
        width={width}
        height={height ? height : width}
        onError={replaceErrorAvatar}
      />
    </span>
  );
};

/* required: display name */
Avatar.displayName = "Avatar";

/* required: props types */
Avatar.propTypes = {
  src: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.any,
  isProcessing: PropTypes.bool,
};

/* required: default props */
Avatar.defaultProps = { isProcessing: false };

export { Avatar };
